export const classes = {
  emptyPlaceholder: {
    textAlign: 'center',
  },
};
